import {Link} from '@/components';
import UserProfile from '@/screens/User/Details/UserProfile';
import type {AdminAfriexPerson} from '@/types';

export type KYCSummaryProp = {
  user: AdminAfriexPerson;
  extraRow?: React.ReactNode;
};

const KYCSummary = ({user, extraRow}: KYCSummaryProp) => {
  return (
    <div className="whitespace-normal break-words bg-white dark:bg-transparent rounded-lg w-full px-5 sm:px-5 py-5 sm:py-5">
      <div className="flex items-center gap-4 mb-3">
        <h2 className="font-semibold text-2xl mr-3">{user.name?.fullName}</h2>
        <Link
          to={`/kyc/${user.id}`}
          target="_self"
          rel="noopener noreferrer"
          className="text-sm text-cyan-700 mr-2 hover:underline"
        >
          View KYC Details
        </Link>
      </div>

      <UserProfile
        type="kyc"
        user={user}
        showEmail
        showUserID
        showKYCStatus
        showRegistrationIP
        showKycProcessors
        showUserLogs
      />

      {extraRow || ''}
    </div>
  );
};

export default KYCSummary;
